import * as React from "react";
import type {
  DebugInferSchemaError,
  Format,
  Schema,
  InferSchemaOptions,
  DirReaderOptions,
} from "@aqora-io/aqora-data-utils";

export type SamplesMeta = {
  samplesRead: number;
  bytesRead: bigint;
};

type ContextValue = {
  files: File[];
  editable: boolean;
  format?: Format;
  setFormat: (format: Format) => void;
  dirReaderOptions?: DirReaderOptions;
  setDirReaderOptions: (dirReaderOptions: DirReaderOptions) => void;
  inferSchemaOptions?: InferSchemaOptions;
  setInferSchemaOptions: (options: InferSchemaOptions) => void;
  inferLoading: boolean;
  schema?: Schema;
  inferError?: Error;
  debugInferError?: DebugInferSchemaError;
  recordBatchesError?: Error;
  samplesMeta?: SamplesMeta;
  uploading: boolean;
  processedBytes: bigint;
  uploadError?: Error;
  upload: (onComplete: () => void) => void;
  cancelUpload: () => void;
};

export const Context = React.createContext<ContextValue>({
  files: [],
  editable: false,
  inferLoading: false,
  setFormat: () => {},
  setDirReaderOptions: () => {},
  setInferSchemaOptions: () => {},
  uploading: false,
  processedBytes: BigInt(0),
  upload: () => {},
  cancelUpload: () => {},
});

export const useContext = () => React.useContext(Context);
